import React from 'react';
import { ProfileSettingsForm } from '../forms';
import { AvatarUpload } from '.';
import { avatarUploaderConfig } from '../../config/uploader';

const PersonalInformation = () => {
  return (
    <div className='max-w-[33.625rem]'>
      <div className='mb-6'>
        <h5 className='text-heading-500 !font-medium'>Profile Picture</h5>
        <p className='text-body-400 mb-0'>PNG or JPG, max 5MB.</p>
      </div>
      <AvatarUpload config={avatarUploaderConfig} />
      <ProfileSettingsForm />
    </div>
  );
};

export default PersonalInformation;
